import { Config } from '@comall-backend-builder/core/lib/parser';
import { ChangePriceSelector } from '../containers';

export let config: Config = {
    entities: {
        // 改价订单列表
        changePrice: {
            apiPath: '/changePrice/find',
            properties: {
                changeCode: {
                    type: 'string',
                    displayName: '改价订单编码',
                },
                orderNo: {
                    type: 'string',
                    displayName: '销售订单编码',
                },
                statusName: {
                    type: 'string',
                    displayName: '状态',
                },
                checkedBy: {
                    type: 'string',
                    displayName: '审核人',
                },
                checkedReason: {
                    type: 'string',
                    displayName: '审核意见',
                },
                checkedTime: {
                    type: 'string',
                    displayName: '审核时间',
                },
            },
            filters: {
                changeCode: {
                    type: 'string',
                    displayName: '改价订单编码',
                    controlConfig: {
                        placeholder: '改价订单编码',
                    },
                },
                orderId: {
                    type: 'string',
                    displayName: '销售订单编码',
                    controlConfig: {
                        placeholder: '销售订单编码',
                    },
                },
                status: {
                    type: 'string.options.select',
                    displayName: '状态',
                    options: [
                        { name: '待审核', id: '0' },
                        { name: '审核成功', id: '10' },
                        { name: '审核失败', id: '20' },
                    ],
                },
            },
        },
        
        // 订单详情基础
        changePriceOrderDetail: {
            apiPath: '/loader/order-change-price-detail',
            properties: {
                changeCode: {
                    type: 'string',
                    displayName: '改价订单编码',
                },
                orderNo: {
                    type: 'string',
                    displayName: '销售订单编码',
                },
                statusName: {
                    type: 'string',
                    displayName: '状态',
                },
                checkedBy: {
                    type: 'string',
                    displayName: '审核人',
                },
                checkedReason: {
                    type: 'string',
                    displayName: '审核意见',
                },
                checkedTime: {
                    type: 'string',
                    displayName: '审核时间',
                },
            },
        },
        // 订单详情商品
        changePriceOrderSknDetail: {
            apiPath: '/loader/order-change-price-detail-skn',
            properties: {
                sknCode: {
                    type: 'string',
                    displayName: 'SKN',
                },
                skuCode: {
                    type: 'string',
                    displayName: 'SKU',
                },
                skuName: {
                    type: 'string',
                    displayName: '商品名称',
                },
                price: {
                    type: 'string',
                    displayName: '售价',
                },
                changePrice: {
                    type: 'string',
                    displayName: '修改价格',
                },
            },
        },
        // 订单审核
        changePriceOrderCheck: {
            apiPath: '/changePrice/check',
            properties: {
                status: {
                    type: 'string.options.radio',
                    displayName: '审核类型',
                    options: [
                        {
                            id: '10',
                            name: '审核通过'
                        },
                        {
                            id: '20',
                            name: '审核不通过'
                        }
                    ],
                    rules: [
                        {
                            required: true,
                            message: '请选择审核类型'
                        },
                    ],
                },
                checkedReason: {
                    type: 'string',
                    displayName: '审核意见',
                    rules: [
                        {
                            required: true,
                            message: '请输入审核意见'
                        },
                    ],
                }
            },
        },
    },
    components: {
        changePricePage: {
            component: 'Viewport',
            entity: 'changePrice',
        },
        // 页面布局
        changePriceListView: {
            component: 'Card',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'changePriceFilter',
                    },
                    {
                        component: 'changePriceBatchBtns',
                    },
                    {
                        component: 'changePriceDataTable',
                    },
                ],
            },
        },
        // 搜索
        changePriceFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'changeCode',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'orderId',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },
        // 中部按钮
        changePriceBatchBtns: {
            component: 'GridLayout',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    text: '新增',
                    type: 'primary',
                    icon: 'plus',
                    route: 'changePrice/create'
                },
            ],
        },
        // 改价列表
        changePriceDataTable: {
            component: 'DataTable',
            switchRefresh: true,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'changeCode',
                },
                {
                    property: 'orderNo',
                },
                {
                    property: 'statusName',
                },
                {
                    property: 'checkedBy',
                },
                {
                    property: 'checkedReason',
                },
                {
                    property: 'checkedTime',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '查看',
                        path: '/trade/changePrice/detail/{{row.changeCode}}',
                    },
                    {
                        // type: 'link',
                        // text: '审核',
                        // path: '/trade/changePrice/check/{{row.changeCode}}',
                        type: 'component',
                        component: 'ChangePriceCheckBtn',
                    },
                ],
            },
        },
        
        // 改价申请
        changePriceOrderCreateView: {
            component: 'Card',
            title: '订单改价申请',
            content: {
                component: 'ChangePriceSelector'
            },
        },
        
        // 改价订单详情
        changePriceOrderDetailView: {
            component: 'FlexLayout',
            direction: 'vertical',
            align: 'justify',
            items: [
                {
                    component: 'Card',
                    title: '基础信息',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'changePriceBaseDetail',
                    },
                },
                {
                    component: 'Card',
                    title: '商品详情',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'GridLayout',
                        direction: 'vertical',
                        align: 'justify',
                        items: [
                            {
                                component: 'changePriceSknDetail',
                            },
                            {
                                text: '返回',
                                component: 'Button',
                                type: 'default',
                                route: 'goBack',
                                style: {
                                    marginTop: '16px',
                                    float: 'right'
                                }
                            },
                        ],
                    },
                },
            ],
        },

        // 改价订单审核
        changePriceOrderCheckView: {
            component: 'FlexLayout',
            direction: 'vertical',
            entity: 'changePriceOrderCheck',
            align: 'justify',
            items: [
                {
                    component: 'Card',
                    title: '基础信息',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'changePriceBaseDetail',
                    },
                },
                {
                    component: 'Card',
                    title: '商品详情',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'changePriceSknDetail',
                    },
                },
                {
                    component: 'Card',
                    title: '审核',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'changePriceCheck',
                    },
                }
            ],
        },

        changePriceBaseDetail: {
            component: 'Detail',
            loaderType: 'get',
            direction: 'vertical',
            entity: 'changePriceOrderDetail',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 4,
            fields: [
                { property: 'changeCode' },
                { property: 'orderNo' },
                { property: 'statusName' },
                { property: 'checkedBy' },
                { property: 'checkedReason' },
                { property: 'checkedTime' },
            ],
        },
        changePriceSknDetail: {
            component: 'DataTable',
            entity: 'changePriceOrderSknDetail',
            loaderType: 'search',
            pagination: false,
            loadFirstPage: true,
            rowKey: 'sknCode',
            columns: [
                {
                    property: 'sknCode',
                },
                {
                    property: 'skuCode',
                },
                {
                    property: 'skuName',
                },
                {
                    property: 'price',
                },
                {
                    property: 'changePrice',
                },
            ],
        },

        changePriceCheck: {
            component: 'CreateForm',
            loaderType: 'get',
            direction: 'vertical',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 24,
                md: 24,
                sm: 24,
            },
            labelCol: 8,
            footer: {
                style: {
                    textAlign: 'right',
                },
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                    },
                    {
                        text: '提交',
                        type: 'primary',
                        htmlType: 'submit',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            fields: [
                {
                    property: 'status',
                },
                {
                    property: 'checkedReason',
                }
            ],
        },

    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    breadcrumbName: '交易管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/changePrice',
                            component: 'changePricePage',
                            breadcrumbName: '订单改价管理',
                            childRoutes: [
                                {
                                    path: '/create',
                                    component: 'changePriceOrderCreateView',
                                    breadcrumbName: '订单改价申请',
                                },
                                {
                                    path: '/detail/:changeCode',
                                    component: 'changePriceOrderDetailView',
                                    breadcrumbName: '订单改价详情',
                                },
                                {
                                    path: '/check/:changeCode',
                                    component: 'changePriceOrderCheckView',
                                    breadcrumbName: '订单改价审核',
                                },
                                {
                                    path: '/',
                                    component: 'changePriceListView',
                                },
                            ]
                            
                        },
                    ],
                },
            ],
        },
    ],
};
